export class ExecuteWorkOrderAction {
  workOrderActionId: string;
  effectiveDate: Date;
}
